<template>
  <div>
    <nav class="navbar navbar-top navbar-expand-md bg-white shadow border-bottom" id="navbar-main">
      <div class="container-fluid">
        <router-link :to="{ name: 'billSearch' }" class="h4 mb-0 text-uppercase d-none d-lg-inline-block">
          Bill Search
        </router-link>
        <user-data></user-data>
      </div>
    </nav>

    <div class="container-fluid mt-0 pt-5 pt-md-8">
      <div class="row">
        <div class="col-md-12 mb-5">
          <div class="card shadow">
            <div class="card-header border-0">
              <h3 class="mb-0">Search Bill</h3>
            </div>

            <div class="card-body">
              <b-form @submit.prevent="generateBill">
                <div class="row m-0">
                  <div class="col-md-4">
                    <b-form-group label="Site" label-for="site">
                      <b-form-select id="site" v-model="form.site_id" class="form-control-alternative"
                        @change="onSiteChange">
                        <option value="null" disabled selected>Please select Site</option>
                        <option v-for="site in coPropList.data" :key="site.id" :value="site.id">
                          {{ site.name }}
                        </option>
                      </b-form-select>
                    </b-form-group>
                  </div>

                  <div class="col-md-4">
                    <b-form-group label="Meter Type" label-for="meterType">
                      <b-form-select id="meterType" v-model="form.service_type_id" class="form-control-alternative"
                        :disabled="!form.site_id" @change="onMeterTypeChange">
                        <option value="null" disabled selected>Please select Meter</option>
                        <option v-for="meter in meterList" :key="meter.id" :value="meter.id">
                          {{ meter.service_name }}
                        </option>
                      </b-form-select>
                    </b-form-group>
                  </div>

                  <div class="col-md-4">
                    <b-form-group label="Lot No" label-for="lotNo">
                      <b-form-select id="lotNo" v-model="form.lot_no" class="form-control-alternative"
                        :disabled="!form.service_type_id">
                        <option value="null" disabled selected>Please select Lot</option>
                        <option v-for="lot in lotList.data" :key="lot.id" :value="lot.lot_no">
                          {{ lot.lot_no }}
                        </option>
                      </b-form-select>
                    </b-form-group>
                  </div>
                </div>

                <div class="row m-0">
                  <div class="col-md-6">
                    <b-form-group label="From Date">
                      <date-picker v-model="form.from" :config="options" class="form-control-alternative"
                        placeholder="Select From Date" />
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group label="To Date">
                      <date-picker v-model="form.to" :config="options" class="form-control-alternative"
                        placeholder="Select To Date" />
                    </b-form-group>
                  </div>
                </div>

                <div class="text-right">
                  <b-button type="submit" variant="primary" class="mt-3"
                    :disabled="!form.lot_no || !form.from || !form.to">
                    Generate Bill PDF
                  </b-button>
                </div>

              </b-form>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import userData from '@/pages/Common/userData'
import datePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'

export default {
  components: {
    userData,
    datePicker
  },
  data() {
    return {
      form: {
        site_id: null,
        service_type_id: null,
        lot_no: null,
        from: '',
        to: ''
      },
      options: {
        format: 'YYYY-MM-DD',
        useCurrent: false
      }
    }
  },
  computed: {
    ...mapGetters('coprops', ['coPropList', 'meterList', 'lotList']),
  },
  methods: {
    ...mapActions('coprops', ['ALL_CO_PROP_LIST', 'ALL_METER_LIST', 'ALL_LOT_LIST']),

    async onSiteChange() {
      if (this.form.site_id) {
        await this.ALL_METER_LIST({ site_id: this.form.site_id })
        this.form.service_type_id = null
        this.form.lot_no = null
      }
    },

    async onMeterTypeChange() {
      if (this.form.site_id && this.form.service_type_id) {
        await this.ALL_LOT_LIST({
          site_id: this.form.site_id,
          service_type_id: this.form.service_type_id
        })
        this.form.lot_no = null
      }
    },

    async generateBill() {
      try {
        const token = localStorage.token;

        if (!token) {
          this.ERROR_TOAST_MSG('No token found, please login again.');
          this.$router.push({ name: 'adminLogin' });
          return;
        }

        const url = `${this.apiUrl}lot-multi-pdf`;
        const params = {
          lot_no: this.form.lot_no,
          from: this.form.from,
          to: this.form.to,
          service_type_id: this.form.service_type_id,
          token: token
        };

        // Download the PDF
        const response = await this.$http.get(url, {
          params,
          responseType: 'blob'  // important to handle PDF files
        });

        // Create a link to download
        const blob = new Blob([response.body], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);

        const fileName = `Bill_${this.form.lot_no}_${this.form.from}_to_${this.form.to}.pdf`;
        link.download = fileName;
        link.click();

        this.SUCCESS_TOAST_MSG('Bill PDF generated successfully.');

      } catch (error) {
        console.error('Error generating bill:', error);

        let errorMessage = 'Failed to generate Bill PDF.';

        if (error.body && error.body.message) {
          errorMessage = error.body.message;
        }

        this.ERROR_TOAST_MSG(errorMessage);
      }
    }
  },
  created() {
    if (!localStorage.token) {
      localStorage.clear()
      this.$router.push({ name: 'adminLogin' })
    } else {
      this.ALL_CO_PROP_LIST()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/Admin/billSearch.vue